// extracted by mini-css-extract-plugin
export default {"loading":"loading__style-2Ljptz76","turn":"turn__style-3wM0uVTw","loadingWrap":"loadingWrap__style-1JwF2jfT"};